'use strict';

var MIN_DATE = new Date(0);

function getTimeString(count, singular, plural) {
  return count === 1 ? singular : plural.replace(/%s/, count);
}

function getDiff(date) {
  var now = new Date(),
      diff = new Date(now - (typeof date === 'string' ? new Date(date) : date)),
      years = diff.getUTCFullYear() - MIN_DATE.getUTCFullYear(),
      months = years === 0 && (diff.getUTCMonth() - MIN_DATE.getUTCMonth()),
      days = months === 0 && (diff.getUTCDate() - MIN_DATE.getUTCDate()),
      weeks = (days - days % 7) / 7,
      hours = days === 0 && (diff.getUTCHours() - MIN_DATE.getUTCHours()),
      minutes = hours === 0 && (diff.getUTCMinutes() - MIN_DATE.getUTCMinutes());

  return { years, months, days, weeks, hours, minutes };
}

function format(date) {
  var diff = getDiff(date);

  if (diff.years) {
    return getTimeString(diff.years, 'a year ago', '%s years ago');
  } else if (diff.months) {
    return getTimeString(diff.months, 'a month ago', '%s months ago');
  } else if (diff.weeks) {
      return getTimeString(diff.weeks, 'a week ago', '%s weeks ago');
  } else if (diff.days) {
    return getTimeString(diff.days, 'a day ago', '%s days ago');
  } else if (diff.hours) {
    return getTimeString(diff.hours, 'an hour ago', '%s hours ago');
  } else if (diff.minutes) {
    return getTimeString(diff.minutes, 'a minute ago', '%s minutes ago');
  } else {
    return 'just now';
  }
}

function normalizeOptions(options) {
  var maxMinutes = options.maxMinutes || null,
      maxHours = maxMinutes !== null ? 0 : (options.maxHours || null),
      maxDays = maxHours !== null ? 0 : (options.maxDays || null),
      maxWeeks = maxDays !== null ? 0 : (options.maxWeeks || null),
      maxMonths = maxWeeks !== null ? 0 : (options.maxMonths || null),
      maxYears = maxMonths !== null ? 0 : (options.maxYears || null);

  return {maxYears, maxMonths, maxWeeks, maxDays, maxHours, maxMinutes};
}

function isAbsolute(date, options) {
  var diff = getDiff(date);

  options = normalizeOptions(options);

  if (options.maxYears !== null && diff.years > options.maxYears) { return true; }
  else if (options.maxMonths !== null && diff.months > options.maxMonths) { return true; }
  else if (options.maxWeeks !== null && diff.weeks > options.maxWeeks) { return true; }
  else if (options.maxDays !== null && diff.days > options.maxDays) { return true; }
  else if (options.maxHours !== null && diff.hours > options.maxHours) { return true; }
  else if (options.maxMinutes !== null && diff.minutes > options.maxMinutes) { return true; }
}

module.exports = {
  format: format,
  isAbsolute: isAbsolute
};


/** WEBPACK FOOTER **
 ** ./utils/TimeAgoFormatter.js
 **/